import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared.module";
import {DateFilterComponent} from "./date-filter.component";

@NgModule({
  declarations: [
    DateFilterComponent
  ],
  exports: [
    DateFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class DateFilterModule {
}
